(function () {
  angular.module("akitabox", ["akitabox.mobile"]);
  angular.module("akitabox.mobile", [
    /* Angular */
    "ngAnimate",
    "ngAria",
    "ngCookies",
    "ngMessages",
    // inject:ngMock
    "ngMaterial",
    "ngSanitize",
    /* Third party */
    "angular.filter",
    "angular-storage",
    "angularFileUpload",
    "bcQrReader",
    "chrome-autofill-fix",
    "ngFileSaver",
    "ui.router",
    "webcam",
    /* Akitabox */
    "akitabox.constants",
    "templates",
    /* Core */
    "akitabox.core",
    "akitabox.core.directives",
    "akitabox.ui",
    /* Mobile */
    "akitabox.mobile.constants",
    "akitabox.mobile.components",
    "akitabox.mobile.directives",
    /* Features */
    "akitabox.asset",
    "akitabox.building",
    "akitabox.dashboard",
    "akitabox.main",
    "akitabox.room",
    "akitabox.serviceRequest",
    "akitabox.workOrder",
    "akitabox.qrCode",
  ]);
})();
